import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { Card, CardHeader, ListItemIcon, Stack } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import request, { gql } from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import { DeleteCustomerMutation } from "../../lib/graphQL/graphMutation";
import {
  AllCustomerDataByMasterQuery,
  AllCustomerDataByUserQuery,
  AllCustomerDetailsQuery,
} from "../../lib/graphQL/graphQuery";
import { useCustomer } from "../../context/apiContext/CustomerContext";
import { useLoading } from "../../context/LodingContext";
import PageLoading from "../../components/Loading/PageLoading";
import TableComponent from "../../components/GridTable/TableComponent";

export default function CustomerListTable() {
  const { authenticated, currentUser } = useAuth();

  const navigate = useNavigate();
  const isUser = currentUser?.role;

  const [id, setId] = useState("");
  const [status, setStatus] = useState(false);
  const { customerData, setCustomerData, isLoading, setIsLoading } =
    useCustomer();
  const { circleLoading, setCirleLoading } = useLoading();

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const fetchCustomerData = () => {
    setIsLoading(true);
    request(
      BASEURL,
      isUser.toLowerCase() == "manager"
        ? AllCustomerDataByMasterQuery
        : isUser.toLowerCase() == "employee"
        ? AllCustomerDataByUserQuery
        : isUser.toLowerCase() == "superuser"
        ? AllCustomerDetailsQuery
        : " ",
      { id: currentUser?.id }
    )
      .then((res) => {
        setCustomerData(
          isUser.toLowerCase() == "manager"
            ? res.getCustomerdetailByMaster
            : isUser.toLowerCase() == "employee"
            ? res.getCustomerdetailByUser
            : isUser.toLowerCase() == "superuser"
            ? res.allCustomer
            : []
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchCustomerData();
    setStatus(false);
  }, [id, status]);

  const customerListTable = {
    columns: [
      {
        label: "S.No",
        field: "sno",
        name: "S No",
        // flex: 1,
        width: 80,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Customer ID",
        field: "cusid",
        name: "Customer id",
        // flex: 1,
        width: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Organization Name",
        field: "legalName",
        name: "User name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Customer Category",
        field: "customerCategory",
        name: "Customer Category",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Created By",
        field: "createdBy",
        name: "Created By",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Created At",
        field: "createdAt",
        name: "Created At",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: customerData.reverse().map((v, i) => ({
      sno: i + 1,
      id: v.id,
      cusid: v.cusid,
      legalName: v.legalName,
      customerCategory: v.customerCategory,
      pan: v.pan,
      createdBy: v.user.username,
      createdAt: v.createdAt ? v.createdAt.slice(0, 10) : "N/A",
    })),
  };

  const handleNewCustomer = () => {
    navigate("/customer-360/add-customer");
  };

  const onCustomerListClick = (e) => {
    if (e?.id) {
      navigate(`/customer-360/add-customer?${e?.id}`);
    }
  };

  
  const onCheck=(list)=>
    {
      console.log("id-c",list)
    }
    
  const onDeleteALL=()=>
    {
      console.log("id-DELE")
    }

  return (
    <DashboardLayout>
      <TableComponent
      tableLoading={isLoading ? true : false}
      columns={customerListTable.columns}
      rowsData={customerListTable.rows}
      head= "Customer List"
      actions={true}
      checked={false}
      view={true}
      showAdd = {true}
      onCheck={onCheck}
      onEdit={onCustomerListClick}
      // onDelete={onDelete}
      onView={onCustomerListClick}
      onDeleteALL={onDeleteALL}
      addList={() => handleNewCustomer()}
      />
      {/* <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Customer List
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleNewCustomer()}
              >
                Add Customer
              </MaterialButton>
            </Stack>
          }
        />
       {!isLoading && <MaterialDataGrid
          // customHeight={550}
          rows={customerListTable.rows}
          columns={customerListTable.columns}
          // checkboxSelection={false}
          isSelectable={false}
          onRowClick={onCustomerListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No employee found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any employee details. Click on the "Add
                  Employee" button to start adding employee details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />}
             {isLoading && <PageLoading />}
      </Card> */}
    </DashboardLayout>
  );
}
